import { gql } from '@apollo/client'

const MENU_CURATION_TASK_REFRESH_COUNTS_QUERY = gql`
  query menuCurationTaskRefreshCounts($id: ID!) {
    menuCurationTask(id: $id) {
      id
      curatedUnknownWordCount
      qadUnknownWordCount
      totalUnknownWordCount
    }
  }
`

export default MENU_CURATION_TASK_REFRESH_COUNTS_QUERY
